import { Component, InputSignal, input, output, inject, WritableSignal, signal } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { Subject, interval, startWith, switchMap, takeUntil } from "rxjs";
import { InvoiceDto } from "../../../../../api/models/fraud.models";
import { dialogRiseAnimation, purchaseCheckPopAnimation } from "../../../../animations/pricing-animations";
import { VariablesService } from "../../../../services/variables.service";
import { PlanUpgradeAwaitingPaymentComponent } from "./components/plan-upgrade-awaiting-payment/plan-upgrade-awaiting-payment.component";
import { PlanUpgradePaidComponent } from "./components/plan-upgrade-paid/plan-upgrade-paid.component";
import { PlanUpgradeRenewPaidComponent } from "./components/plan-upgrade-renew-paid/plan-upgrade-renew-paid.component";
import { ApiService } from "../../../../../api/services/api.service";

@Component({
  selector: 'app-invoice-plan-upgrade',
  imports: [
    PlanUpgradePaidComponent,
    PlanUpgradeAwaitingPaymentComponent,
    PlanUpgradeRenewPaidComponent,
    MatProgressSpinnerModule
],
  templateUrl: './invoice-plan-upgrade.component.html',
  styleUrl: './invoice-plan-upgrade.component.scss',
  animations: [dialogRiseAnimation, purchaseCheckPopAnimation],
  host: {
    class: 'flex flex-col w-full h-full min-h-0',
  },
})
export class InvoicePlanUpgradeComponent {
  public readonly invoiceUuid: InputSignal<string> = input.required<string>();

  public readonly outputInvoiceStatus = output<'ACTIVE' | 'PAID' | 'WAITING_FOR_PAYMENT' | 'CANCELED'>();

  readonly _apiService: ApiService = inject(ApiService);
  readonly variablesService: VariablesService = inject(VariablesService);

  readonly invoice: WritableSignal<InvoiceDto | null> = signal<InvoiceDto | null>(null);
  private readonly _destroy$ = new Subject<void>();
  private readonly _stopPolling$ = new Subject<void>();

  ngOnInit(): void {
    this._getInvoice();
  }

  ngOnDestroy(): void {
    this._stopPolling$.next();
    this._stopPolling$.complete();
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _getInvoice(): void {
    interval(20000).pipe(
      startWith(0),
      switchMap(() => this._apiService.getInvoice(this.invoiceUuid())),
      takeUntil(this._stopPolling$),
      takeUntil(this._destroy$),
    ).subscribe({
      next: (invoice: InvoiceDto) => {
        this.invoice.set(invoice);
        this.outputInvoiceStatus.emit(invoice.status);
        if (invoice.status !== 'WAITING_FOR_PAYMENT') {
          this.variablesService.triggerBannersReload();
          this._stopPolling$.next();
        }
      }
    });
  }
}
